var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M15 21.074 21.18 25l-1.64-7.4L25 12.621l-7.19-.642L15 5l-2.81 6.979L5 12.62l5.46 4.979L8.82 25z"
  })));
};
export default SvgNew;